module.exports = __webpack_public_path__ + "main/assets/fonts/petalmd/petalmd-f80d056288a478fc6bd62f8fb8099f45.woff";


//////////////////
// WEBPACK FOOTER
// ./main/assets/fonts/petalmd/petalmd.woff
// module id = 470
// module chunks = 0